<template>
  <div class="layout-standalone">
    <slot />
  </div>
</template>

<script setup lang="ts">
  // No special logic needed for this layout
</script>

<style lang="scss" scoped>
  .layout-standalone {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    background: var(--color-base-white);
  }
</style>
